import * as React from "react";

export interface IWizardProgressItemProps {
	title: string;
	name: string;
	selected?: boolean;
	completed?: boolean;
	onClick: () => void;
}

export class WizardProgressItem extends React.Component<IWizardProgressItemProps> {
	constructor(props: IWizardProgressItemProps) {
		super(props);
	}

	render() {
		return <div onClick={(e) => this.props.onClick()} className={`wizard-progress-item${(this.props.completed ? " completed" : "") + (this.props.selected ? " selected" : "")}`}>
			<div className="check"></div>
			<span>{this.props.title}</span>
		</div>;
	}
}

export default WizardProgressItem;